import getFromProcessEnv from 'constants/utils/getFromProcessEnv';

const protocol = getFromProcessEnv('REACT_APP_PROTOCOL');
const deploy = getFromProcessEnv('REACT_APP_DEPLOY');
const domain = getFromProcessEnv('REACT_APP_DOMAIN');

const apiURL = `${protocol}://${deploy}.${domain}/resources/`;

export default apiURL;
